var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbuntuAzureLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -18.713,
    y1: 1.674,
    x2: -19.201,
    y2: 0.71,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -13.307,
    y1: 1.225,
    x2: -13.388,
    y2: 1.199,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.302
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -18.181,
    y1: 1.702,
    x2: -17.672,
    y2: 0.748,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ccbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892df"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(-513 -415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UbuntuProductLogo",
    transform: "translate(513 415)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 74,
    height: 75,
    rx: 6,
    fill: "#ff5722"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(-676.21 -199.796)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 5.896,
    cy: 5.896,
    r: 5.896,
    transform: "translate(682.916 231.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 5.896,
    cy: 5.896,
    r: 5.896,
    transform: "translate(721.823 253.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 5.896,
    cy: 5.896,
    r: 5.896,
    transform: "translate(721.823 208.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M221.942,54.339a1.179,1.179,0,0,0,1.309.554A11.724,11.724,0,0,1,237.467,63.1a1.179,1.179,0,0,0,1.134.858h9.637a1.179,1.179,0,0,0,1.18-1.179,1.2,1.2,0,0,0-.015-.187,23.523,23.523,0,0,0-5.363-11.606,1.179,1.179,0,0,0-1.547-.207,8.247,8.247,0,0,1-12.823-6.755,1.179,1.179,0,0,0-1.054-1.156A23.656,23.656,0,0,0,217.708,44.3a1.179,1.179,0,0,0-.6,1.691Z",
    transform: "translate(489.801 170.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M248.358,277.333h-9.637a1.179,1.179,0,0,0-1.134.858,11.719,11.719,0,0,1-14.217,8.205,1.179,1.179,0,0,0-1.309.554l-4.821,8.351a1.179,1.179,0,0,0,.6,1.691,23.289,23.289,0,0,0,10.908,1.429,1.179,1.179,0,0,0,1.054-1.156,8.236,8.236,0,0,1,12.809-6.755,1.179,1.179,0,0,0,1.549-.215,23.522,23.522,0,0,0,5.363-11.6,1.179,1.179,0,0,0-.978-1.351A1.2,1.2,0,0,0,248.358,277.333Z",
    transform: "translate(489.684 -37.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M111.686,114.979a11.769,11.769,0,0,1,0-16.422,1.179,1.179,0,0,0,.175-1.415l-4.814-8.332a1.179,1.179,0,0,0-.809-.571,1.231,1.231,0,0,0-.958.236,23.6,23.6,0,0,0-7.434,10.648,1.179,1.179,0,0,0,.366,1.295,8.125,8.125,0,0,1,0,12.7,1.179,1.179,0,0,0-.366,1.295,23.6,23.6,0,0,0,7.431,10.639,1.179,1.179,0,0,0,.745.264,1.291,1.291,0,0,0,.212-.019,1.179,1.179,0,0,0,.809-.571l4.814-8.337A1.179,1.179,0,0,0,111.686,114.979Z",
    transform: "translate(595.795 130.527)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(536 437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    transform: "translate(-171.936 315.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M10.99,6.543h6.2L10.754,25.617a.989.989,0,0,1-.937.673H4.991a.987.987,0,0,1-.935-1.3l6-17.771a.989.989,0,0,1,.937-.673Z",
    transform: "translate(708.997 120.544)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M38.261,60.261H28.427a.455.455,0,0,0-.311.788l6.319,5.9a.993.993,0,0,0,.678.267h5.568Z",
    transform: "translate(690.737 79.619)",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M10.994,6.544a.981.981,0,0,0-.939.686L4.067,24.971A.986.986,0,0,0,5,26.29H9.948a1.058,1.058,0,0,0,.812-.691l1.194-3.519,4.265,3.978a1.009,1.009,0,0,0,.635.231H22.4l-2.433-6.953-7.093,0L17.217,6.544Z",
    transform: "translate(708.993 120.543)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M41.495,7.216a.987.987,0,0,0-.935-.672H33.648a.987.987,0,0,1,.935.672l6,17.772a.987.987,0,0,1-.935,1.3h6.911a.987.987,0,0,0,.935-1.3Z",
    transform: "translate(686.412 120.543)",
    fill: "url(#linear-gradient-3)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbuntuAzureLogo);
export default __webpack_public_path__ + "static/media/ubuntu-azure-logo.85d78f98989361050b6468d51fb17282.svg";
export { ForwardRef as ReactComponent };